import React, { useEffect } from 'react'
import { useFetch } from 'hooks/useFetch'
import SectionError from 'components/error/SectionError'
import Loader from 'components/loader/Loader'

const T = {
  bg:   '#F6F5F0',
  card: '#FFFFFF',
  line: '#E5E2D8',
  ink:  '#232821',
  mut:  '#6E766C',
  acc:  '#2E9E7A',
};

const IndexPresenceContainer = (props) => {
  const { url, title } = props
  const { data: rawData, loading, error, retry } = useFetch(url)
  const data = rawData || []

  return (
    <div style={{
      background: T.card,
      borderRadius: 16,
      border: `1px solid ${T.line}`,
      padding: '18px 20px',
      boxSizing: 'border-box',
      height: '100%',
      maxHeight: 275,
      overflowY: 'auto',
    }}>
      <div style={{
        fontFamily: "'Bricolage Grotesque', sans-serif",
        fontSize: 16,
        fontWeight: 700,
        color: T.ink,
        marginBottom: 14,
      }}>
        {title}
      </div>

      {loading ? (
        <Loader />
      ) : error ? (
        <SectionError message={error.message} onRetry={retry} />
      ) : data.length ? (
        <ul style={{ listStyle: 'none', margin: 0, padding: 0, columns: 2, columnGap: 16 }}>
          {data.filter(item => item.name !== '').map((item, index) => (
            <li key={index} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              fontSize: 12.5,
              color: T.ink,
              marginBottom: 8,
              breakInside: 'avoid',
            }}>
              <span style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                background: T.acc,
                flexShrink: 0,
                display: 'inline-block',
              }} />
              {item.name}
            </li>
          ))}
        </ul>
      ) : (
        <div style={{ color: T.mut, fontSize: 13, textAlign: 'center', padding: '24px 0' }}>
          No data available
        </div>
      )}
    </div>
  )
}

export default IndexPresenceContainer
